import { Toast } from "zarm";

import { isObject } from "../../utils/tools";
import { OptionsProps } from "../../utils/type";

import { PickerStepProps, IDisplayRender } from './type';

let tempValue: any[] = [];
let isBreak = false;

export const getColValue = (data: OptionsProps, value: any, valueMember: string, ...ags) => {
  if (value && Array.isArray(value) && value.length) {
    tempValue = value;
    return false;
  }

  // 首次进入，清空数组
  if (ags && ags.length <= 1) {
    tempValue = [];
    isBreak = false;
  }

  if (!(value && isObject(value))) {
    return false;
  }

  // 从数据源中匹配到默认值
  if (data && Array.isArray(data) && data.length) {
    const len = data.length;
    let i = 0;
    let item: any = null;

    for (; i < len; i += 1) {
      item = data[i];

      if (item[valueMember] === value[valueMember]) {
        isBreak = true;

        /* eslint-disable no-loop-func */
        if (ags && Array.isArray(ags) && ags.length) {
          ags.forEach(v => {
            tempValue.push(v);
          });
        }

        tempValue.push(item);
      } else if (item.children) {
        getColValue(item.children, value, valueMember, ...ags, item);
      }

      if (isBreak) {
        break;
      }
    }
  }
};

export const getValue = (props: PickerStepProps, dataSource?: OptionsProps) => {
  const { value, options, valueMember = "value" } = props;
  let { defaultValue } = props;
  const isData =
    (options && Array.isArray(options) && options.length) || (dataSource && Array.isArray(dataSource) && dataSource.length);

  if (value) {
    defaultValue = value;
  }

  // 同步数据 设置 tempValue
  if (options && Array.isArray(options) && options.length) {
    getColValue(options, defaultValue, valueMember);
    // 异步接口请求 设置  tempValue
  } else if (dataSource && Array.isArray(dataSource) && dataSource.length) {
    getColValue(dataSource, defaultValue, valueMember);
  }

  return {
    selected: defaultValue,
    defaultValue: isData ? tempValue : []
  };
};

/**
 * 
 * @param param0 
 * @returns 
 */
export const disabledLevel = ({ item, min, max }) => {
  return item && item.level && ((min && item.level < min) || (max && item.level > max));
};


/**
 * 验证职业等级限制
 * @param param0 最小等级，最大等级，当前选中的数据
 * @returns 
 */
export const validateLevel = ({ min, max, cols }) => {

  if (cols && Array.isArray(cols) && cols.length) {
    const item = cols[cols.length - 1];

    if (disabledLevel({ item, min, max })) {
      Toast.show("该职业不可投保此产品/计划");
      return `本产品仅支持${min}-${max}类职业，您无法投保`;
    }
  }
  if (cols && isObject(cols)) {
    if (disabledLevel({ item: cols, min, max })) {
      Toast.show("该职业不可投保此产品/计划");
      return `本产品仅支持${min}-${max}类职业，您无法投保`;
    }
  }

  return "";
};

/**
 * 取出数组的label渲染
 * @param selected  any[] 选中的数据
 * @param reverse  boolean 是否翻转
 * @param showAll  boolean 是否展示全部，还是只展示最后一项
 * @returns 
 */
export const displayRender = ({ selected, reverse, showAll }: IDisplayRender) => {

  if (!(selected && Array.isArray(selected) && selected.length)) {
    return null;
  }

  if (showAll) {
    const label: string[] = [];

    selected.map(item => {
      if (reverse) {
        label.push(item.label);
      } else {
        label.unshift(item.label);
      }
      return item;
    });

    return label.join("");
  }

  return selected[selected.length - 1].label;
};

/**
 * 选择的数据格式化为后端需要的数据
 * @param selected 
 * @returns 
 */
export const formatOkValue = (selected) => {
  if (selected && Array.isArray(selected) && selected.length) {
    const len = selected.length;
    const value = { ...selected[len - 1] };

    if (len > 1) {
      const parents: any[] = [];

      selected.map((item, index) => {
        if (index < len - 1) {
          item = { ...item };

          // 优化数据结构
          if (item.children) {
            delete item.children;
          }

          parents.push(item);
        }

        return item;
      });

      value.parents = parents;
    }

    return value;
  }
  return false;
};

/**
 * 根据当前节点 value 获取当前节点的列表或者当前节点下面节点的列表
 * @param data
 * @param item 
 * @param callback((depthList, i) => depthList || depthList[i].children)
 * @returns 
 */
export const getSourceByValue = (data, item, callback) => {
  let tempList = [];
  const depthFirst = depthList => {
    for (let i = 0; i < depthList.length; i++) {
      if (depthList[i].value === item.value) {
        tempList = callback(depthList, i);
        break;
      } else if (depthList[i].children) {
        depthFirst(depthList[i].children);
      }
    }
  };
  depthFirst(data);
  return tempList;
};


// const obtainItem = (list, value) => {
//   return list.filter(item => item[valueMember] === value)[0];
// };

// const resolveProps = () => {
//   const {
//     value, dataSource, validate,
//   } = props;
//   let resolveValue = [];
  // value.reduce((list, item) => {
  //   const valueItem = obtainItem(list, item);

  //   if (valueItem) {
  //     resolveValue.push(valueItem);

  //     return valueItem.children || [];
  //   }

  //   return [];
  // }, dataSource);

  // 查询子级
//   if (resolveValue.length < value.length) {
//     resolveValue = [];
//   }

//   return {
//     value: resolveValue,
//     displayValue: [...resolveValue],
//     errorMsg: validate(value) || '',
//   };
// };